<template>
    <div>

    </div>

</template>

<script>
    export default {
        name: "Home",
    };
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Home.vue